import React from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import { Scales } from "@phosphor-icons/react";
import { TURNSTILE_SITE_KEY } from "./caseQuizLogic";
import { ConsentText } from "../trustedForm";

export const ConsentStep = ({ a, set, tcpa, firmName, turnstileEnabled, onToken, turnstileRef }) => (
  <div data-testid="case-quiz-consent">
    {firmName && (
      <div className="mb-3 flex items-center gap-2 rounded-lg border border-white/10 bg-white/[0.04] px-3 py-2 text-sm text-slate-300" data-testid="case-quiz-consent-firm">
        <Scales size={16} weight="duotone" className="text-[var(--cf-accent)]" />
        Your case goes to <b className="text-white">{firmName}</b>
      </div>
    )}
    <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-white/10 bg-white/[0.03] p-3.5" data-tf-element-role="consent-language">
      <input
        type="checkbox"
        name="consent"
        checked={a.consent}
        onChange={(e) => set("consent", e.target.checked)}
        className="mt-0.5 h-5 w-5 shrink-0 accent-[var(--cf-accent)]"
        data-tf-element-role="consent-opt-in"
        data-testid="tcpa-consent-checkbox"
      />
      <span className="tf-tagged-consent text-[11.5px] leading-relaxed text-slate-400" data-testid="tcpa-consent-text">
        <ConsentText text={tcpa} advertiser={firmName} />
      </span>
    </label>
    {turnstileEnabled && (
      <div className="mt-3" data-testid="case-quiz-turnstile">
        <Turnstile
          ref={turnstileRef}
          siteKey={TURNSTILE_SITE_KEY}
          onSuccess={onToken}
          onError={() => onToken("")}
          onExpire={() => onToken("")}
          options={{ theme: "dark", size: "flexible" }}
        />
      </div>
    )}
  </div>
);
